import { CloseIcon } from '../../../assets/icons/Svg';
import { useDispatch, useSelector } from 'react-redux';
import { clearTypeModal, selectCurrentAdditionalModalType, setTypeOfAdditionalModal } from '../../../features/modal/modalSlice';
import { formatCurrency } from '../../../utils/formatAmount';
import { TypcnDownload } from '../../../assets/icons/Icons';
import { useMutationData } from '../../../hooks/api/useMutationData';
import { clearSelectedClientReport, setSelectedClientIdBillingReport, setSelectedDeceaseName } from '../../../features/reports/reportsSlice';
import useReport from '../../../hooks/actions/useReport';
import ExportBillingTypeModal from './ExportBillingTypeModal';

export default function ClientReport() {
    
    const dispatch = useDispatch();
    const typeAdditionalModal = useSelector(selectCurrentAdditionalModalType);
    const { handleGenerateReportClient,  isExportClientBtnDisable, initialName, dateRangeFormat, timeRangeFormat, amountToBeBilled, totalPackageSales, clientPackages, chapelName, deceasedName, selectedClientId, isLoadingExportBillingReport } = useReport()
    const { isLoadingExportSalesExcel } = useMutationData()
    const isDisabled = isLoadingExportBillingReport || isLoadingExportSalesExcel || isExportClientBtnDisable

    const handleCloseClientReport = () => {
        dispatch(clearTypeModal())
        dispatch(clearSelectedClientReport())
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[99]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[70%] lg:w-[50%]'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    Client Report
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center disabled:cursor-not-allowed"
                                    disabled={isDisabled}
                                    onClick={handleCloseClientReport}
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='space-y-2'>
                            <div className="flex items-center gap-3 py-3">
                                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-cbColor text-sm font-semibold text-white">
                                    {initialName}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="truncate text-sm uppercase font-semibold text-gray-900">{deceasedName}</p>
                                    <p className="text-xs text-gray-500">{chapelName}</p>
                                </div>
                            </div>
                            <div className="space-y-3 pb-2 text-sm text-gray-600">
                                <div className="grid grid-cols-2 gap-1.5">
                                    <div>
                                        <p className="text-xs font-medium text-gray-500 uppercase">DATE</p>
                                        <p className="text-xs font-medium text-gray-800">{dateRangeFormat}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-500">TIME</p>
                                        <p className="text-xs font-medium text-gray-800">{timeRangeFormat}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-500">ACTUAL SALES</p>
                                        <p className="text-xs font-medium text-gray-800">{`₱${formatCurrency(totalPackageSales)}`}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-500">ACTUAL BILLED</p>
                                        <p className="text-xs font-medium text-gray-800">{`₱${formatCurrency(amountToBeBilled)}`}</p>
                                    </div>
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-500">PACKAGE/S (REMAINING):</p>
                                    <div className="space-y-1">
                                        {clientPackages?.map((pkg, indx) => {
                                            return (
                                                <div key={indx}>
                                                    <div className="flex justify-between text-xs font-medium">
                                                        <span className="text-gray-700">{pkg.packageName}</span>
                                                        <span className="text-gray-500">{`${pkg.cupsAvailable}/${pkg.totalquantity}`}</span>
                                                    </div>
                                                    <div className="mt-1 h-2 w-full rounded bg-gray-200">
                                                        <div 
                                                            className="h-2 rounded bg-gray-500 transition-all" 
                                                            style={{  width: `${(pkg.cupsAvailable / pkg.totalquantity) * 100}%`}}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex justify-end gap-3'>
                                <button
                                    onClick={handleGenerateReportClient}
                                    disabled={isDisabled}
                                    className={`flex items-center text-xs px-4 py-1.5 rounded font-medium transition-all bg-cbColor shadow-md text-white disabled:cursor-not-allowed`}
                                >
                                    {isLoadingExportSalesExcel ? (
                                        <span>Exporting...</span>
                                    ) : (
                                        <>
                                            <span className='mr-1'>
                                                <TypcnDownload height={18} width={18} />
                                            </span>
                                            <span>Export Report</span>
                                        </>
                                    )}
                                    
                                </button>
                                <button
                                    // onClick={handleGenerateReportClient}
                                    onClick={() => {
                                        if(!deceasedName || !selectedClientId) return
                                        dispatch(setSelectedClientIdBillingReport(selectedClientId))
                                        dispatch(setSelectedDeceaseName(deceasedName))
                                        dispatch(setTypeOfAdditionalModal('showExportBillingTypes'))
                                    }}
                                    disabled={isDisabled}
                                    className={`flex items-center text-xs px-4 py-1.5 rounded font-medium transition-all bg-cbColor shadow-md text-white disabled:cursor-not-allowed`}
                                >
                                    {isLoadingExportBillingReport ? (
                                        <span>Exporting...</span>
                                    ) : (
                                        <>
                                            <span className='mr-1'>
                                                <TypcnDownload height={18} width={18} />
                                            </span>
                                            <span>Export Billing</span>
                                        </>
                                    )}
                                    
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {typeAdditionalModal === 'showExportBillingTypes' && (<ExportBillingTypeModal/>)}
        </div>
    )
}
